"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _request = _interopRequireDefault(require("@/utils/request"));
var _default = exports.default = {
  data: function data() {
    return {};
  },
  methods: {
    /**
     * @description: 表格操作按钮点击事件
     * @param { Object } btn 按钮对象
     * @return { void }
     */
    exportExcel: function exportExcel(btn) {
      var _ref,
        _btn$exportUrl,
        _this = this;
      var url = (_ref = (_btn$exportUrl = btn.exportUrl) !== null && _btn$exportUrl !== void 0 ? _btn$exportUrl : btn.url) !== null && _ref !== void 0 ? _ref : null;

      // console.log(this)
      if (url) {
        this.$confirm('是否确认导出?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          var _this$$refs$wlDrawer, _this$$refs$wlDrawer2, _ref2, _btn$options;
          var condition = (_this$$refs$wlDrawer = (_this$$refs$wlDrawer2 = _this.$refs['wl-drawer-search']) === null || _this$$refs$wlDrawer2 === void 0 ? void 0 : _this$$refs$wlDrawer2.getQueryCondition()) !== null && _this$$refs$wlDrawer !== void 0 ? _this$$refs$wlDrawer : {};
          var option = (0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, {
            pageSize: 999999,
            pageNum: 1
          }), _this.tableSort), condition), _this.queryParams);
          Object.assign(option, (_ref2 = (_btn$options = btn.options) !== null && _btn$options !== void 0 ? _btn$options : btn.option) !== null && _ref2 !== void 0 ? _ref2 : {});
          (0, _request.default)({
            url: url,
            method: 'POST',
            responseType: 'json',
            data: option
          }).then(function (res) {
            if (res && res.code === 200) {
              _this.download(res.data);
            }
          });
        }).catch(function (e) {
          return console.error(e);
        });
      } else {
        this.$message.warning("\u6CA1\u6709\u627E\u5230\u5BFC\u51FA\u5730\u5740");
      }
    }
  }
};